<template>
  <div class="layout-padding">


    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="전체 업체 문의 조회"
      desc="전체 업체 문의 내역들의 현황을 조회할 수 있습니다.">
      <!-- 문의 카테고리 -->
      <div slot="inquiry_category">
        <span class="select">
          <select @change="selectCategory">
            <option value="" disabled selected>카테고리</option>
            <option v-for="(cat, idx) in cat_arr"
                    :key="'cat'+idx"
                    :value="cat.value">{{ cat.label }}</option>
          </select>
        </span>
      </div>
    </admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 :table_width="1200"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="user_type" slot-scope="props">
        <div v-if="props.item.user">회원</div>
        <div v-else>비회원</div>
      </div>

      <div slot="name" slot-scope="props">
        <div v-if="props.item.user">{{ props.item.user_data.name }}</div>
        <div v-else>{{ props.item.name }}</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button" @click="clickAnswer(props.item.id)">상세보기</button>
      </div>

      <div slot="confirm_status" slot-scope="props" style="width: 120px; margin: auto;">
        <div v-if="!props.item.is_new">미확인</div>
        <div v-else>확인</div>
      </div>

      <div slot="comment_status" slot-scope="props" style="width: 120px; margin: auto;">
        <button v-if="props.item.is_answered"
                class="button is-grey cancel"
                @click.stop.prevent="clickAnswer(props.item.id)">답변 수정</button>
        <button v-if="!props.item.is_answered"
                class="button state-btn btn-make-comment"
                @click.stop.prevent="clickAnswer(props.item.id)">답변 달기</button>
        <button v-if="props.item.is_answered"
                class="button state-btn">답변 확인</button>
      </div>

    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  import moment from 'moment';
  import { SweetModal } from "sweet-modal-vue";
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpRadio from '../../module/common/LpRadio'

  import LpInputText from "../../module/common/LpInputText";

  export default {

    mixins: [
      ListMixin
    ],

    components: {
      LpInputText,
      SweetModal,
      LpSortDropDown,
      LpRadio
    },
    created() {
      this.nowTime = moment().format("YY-MM-DD");
      //this.getData();
      this.initializing('partner_inquiry_all', 'inquiry/partner');
      this.getCategory();
    },
    data() {
      return {
        tableItems: [],
        qnaItem:{
          id:0,
          answer_content:''
        }
      };
    },
    watch: {
      'filtered.ordering'(){
        this.getData();
      },
      'filtered.is_new'(){
        this.getData();
      },
      'filtered.is_answered'(){
        this.getData();
      }
    },
    methods: {
      getCategory(){
        this.$axios.get('admin/inquiry/partner/category').then(res=>{
          if(res.status===200){
            this.cat_arr = res.data;
          }
        })
      },
      getDataFromServer() {
        this.getData();
      },
      // 문의 카테고리 선택
      selectCategory(e) {
        this.filtered.category = e.target.value;
        this.getData();
      },
      // 답변 달기
      clickAnswer(id){
        this.$router.push(this.getPath('partner/inquiry/create?id='+id));
      },
      clickConfirm(item) {
        // 서버에 확인 상태 전송
        this.$axios.post(this.getUrl('inquiry/partner/'+ item.id)).then(res => {
          if(res.status===200){
            this.getData();
          }
        });
      },
      clickItem(item, type) {
        if (type === "update") {
          this.$router.push("/office/admin/ProdQnaReg?id=" + item.id);
        } else if (type === "delete") {
          this.$axios.post("del_prod_question?id=" + item.id).then(() => {
            this.tableItems = this.tableItems.filter(value => {
              return value.id != item.id;
            });
          });
        }
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  @import '~assets/css/lp_main';

  .tr-whole-border th
    padding 12px 6px

  .many-field-tr td
    padding 6px

  .progress-btn
    border-radius 3px
    display inline-block
    width 84px
    padding 6px 0
    margin 2px
    font-weight bold
    font-size .8rem

  .bid-state
    margin 2px 0
    color #fff
    border-radius 3px
    display inline-block
    width 76px
    padding 4px

  .btn-request-sheet
    color white
    background-color #5cb85c

  .bid-state-done
    background-color #5cb85c
  .bid-state-ing
    background-color #1c7cd5
  .bid-state-ok
    background-color #5cb85c
  .bid-state-no
    background-color #f0ad4e

  .q-title
    font-size 0.9rem
    color $primary
    margin-top 20px
    margin-bottom 4px

  .est-title
    padding 20px
    font-size 1.2rem
    border-bottom 1px solid $primary

  .est-table
    padding 20px
    max-height 80vh

  .est-table table
    width 100%

  .est-table table
  .est-table th
  .est-table td
    border 0
    padding 4px 0
    text-align center

  .modal-title
    margin 20px 0 8px 0
    color #064160
    font-size 0.9rem
    font-weight bold

  .modal-desc
    padding 20px
    background-color #eee

  .td-est:hover
    background-color #eeeeee
    cursor pointer

  .lp-btn-bid
    cursor pointer
    border-radius 3px
    color white
    padding 4px 6px
    font-size 0.8rem
    width 74px
    margin auto
    margin-top 4px
    background-color $primary

  .btn-add
    width 24px
    height 24px
    line-height 23px
    text-align center
    font-size 1rem
    color white
    background-color $primary
    border-radius 50%

  .lp-custom-modal-btns
    padding 20px

  .btn-close
    width 45px
    color #777
    text-align center
    margin auto 0


</style>
